/**
 * Settings > Claims config-list tabs. Each wraps the generic
 * ClaimOptionListTab, pointing it at the entity attribute that backs the
 * option list and the RBAC codename prefix that gates it.
 */

import { ClaimOptionListTab } from './claim-option-list-tab'

export function PaymentTypesTab() {
  return (
    <ClaimOptionListTab
      entityKey="claim_payment"
      attributeCode="payment_type"
      permissionPrefix="payment-types"
      eyebrow="Settlement config"
      title="Payment Types"
      description="The payment types selectable on claim payments (e.g. Labor, Taxes, Dumpster Charges). These feed the settlement payments table."
      noun="payment type"
    />
  )
}

export function UnitsOfMeasureTab() {
  return (
    <ClaimOptionListTab
      entityKey="settlement_line_item"
      attributeCode="uom"
      permissionPrefix="units-of-measure"
      eyebrow="Settlement config"
      title="Units of Measure"
      description="The units of measure selectable on settlement line items (e.g. Each, Squares, Linear Feet). These feed the line-items table UOM column."
      noun="unit of measure"
    />
  )
}

export function ClaimLabelsTab() {
  return (
    <ClaimOptionListTab
      entityKey="claim"
      attributeCode="labels"
      permissionPrefix="claim-labels"
      eyebrow="Claim config"
      title="Labels"
      description="Labels operators can apply to a claim for triage and filtering. These appear as a multi-select on the claim detail page."
      noun="label"
      withColor
    />
  )
}

export function EscalationReasonsTab() {
  return (
    <ClaimOptionListTab
      entityKey="claim"
      attributeCode="escalation_reason"
      permissionPrefix="escalation-reasons"
      eyebrow="Claim config"
      title="Escalation Reasons"
      description="The reasons an operator can pick when escalating a claim. These populate the reason dropdown on the Escalate action."
      noun="escalation reason"
    />
  )
}
